import { iconsService } from '../../../services/IconsService';
import {
  HeaderServiceManager,
  IHeaderServiceManager,
} from '../../../serviceContextManager/layout/HeaderServiceManager';
import React, { useContext } from 'react';
import { validatePermissions } from '../../../utils/utils';
export const Sidebar = ({}) => {
  const { sidebarItems, onSelectedNavItem } =
    useContext<IHeaderServiceManager>(HeaderServiceManager);
  const service = iconsService;
  const isSelected = window.location.pathname;

  return sidebarItems.length > 0 ? (
    <div className="w-24 h-full flex-col border-grey bg-white shadow-2xl rounded-r-2xl">
      {sidebarItems.map(item => {
        if (validatePermissions(item.permit)) {
          return (
            <div
              onClick={() => onSelectedNavItem(item.to)}
              key={item.to}
              className={`flex flex-col mt-5 justify-center text-center cursor-pointer shadow-lg text-grey hover:!text-official_green ${
                item.to === isSelected ? 'text-official_green' : ''
              }`}>
              <div className="flex w-full h-8 justify-center content-center items-center cursor-pointer">
                {service.getIcon(item.icon)}
              </div>
              {item.label}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  ) : null;
};
